import { render, staticRenderFns } from "./notas.vue?vue&type=template&id=e98dce8a&scoped=true"
import script from "./notas.vue?vue&type=script&lang=js"
export * from "./notas.vue?vue&type=script&lang=js"
import style0 from "./notas.vue?vue&type=style&index=0&id=e98dce8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98dce8a",
  null
  
)

export default component.exports